import * as a from "react";
import m from "../lib/IconBase.es.js";
import t from "../defs/Camera.es.js";
const e = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(m, { ref: r, ...o, weights: t }));
e.displayName = "CameraIcon";
const n = e;
export {
  n as Camera,
  e as CameraIcon
};
